// Keep in sync with benchling/pipelines/steps/constants.py
export const MAX_NUM_OUTPUTS = 150;
export const EXCEEDED_MAX_NUM_OUTPUTS_MESSAGE = `Cannot export more than ${MAX_NUM_OUTPUTS} items`;
